import React from "react";
import { FixedCard as Card } from "./PendingAssessments.styles";

interface Props {
  goToAssessment: any;
}

function PendingAssessment(props: Props) {
  const { goToAssessment } = props;

  return (
    <Card>
      <h2 className="ass-heading">
        You have a pending assessment
      </h2>
      <button onClick={goToAssessment} style={{ backgroundColor: "#f56f3f" }}>
        Take it
      </button>
    </Card>
  );
}

export default PendingAssessment;



// WEBPACK FOOTER //
// ./src/components/Ploa2Cards/PendingAssessment.tsx